import { Injectable } from "@angular/core";
import { HttpHeaders, HttpErrorResponse } from "@angular/common/http";
import { environment } from "../../environments/environment";
import { Util } from "./util";
import { Component, Input } from "@angular/core";
import { Observable, throwError } from "rxjs";
import { map, catchError } from "rxjs/operators";
import { Location } from "@angular/common";
import * as CryptoJS from "crypto-js"; // Import crypto-js

@Injectable()
export class HttpServer {
  constructor(
    private util: Util,
    private loc: Location,
  ) {}

  SendData(
    model: any,
    url: any,
    mode: string,
    isBannerNeed = true,
    isDirectUrl = false,
    token = null,
    bannerId = "1",
  ) {
    // Build API URL

    if (isDirectUrl === true) {
      url = url;
    } else {
      if (this.util.isProd()) {
        url = environment.prodShoreAPI + "/" + url;
      } else if (this.util.isUAT()) {
        url = environment.uatShoreAPI + "/" + url;
      } else if (this.util.isDev()) {
        url = environment.devShoreAPI + "/" + url;
      } else {
        url = environment.uatShoreAPI + "/" + url;
      }
    }

    // Headers
    let headers: any = {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "",
      Banner: "",
    };

    // Banner logic
    if (url.includes("7py8fahnf3") || url.includes("llz1npmgm7")) {
      if (bannerId != null && bannerId.toString() === "2") {
        headers.Banner = "lucky";
      } else if (bannerId != null && bannerId.toString() === "3") {
        headers.Banner = "foodmaxx";
      } else {
        headers.Banner = "savemart";
      }
    }

    // Remove Banner header if empty
    if (!this.util.IsNotEmpty(headers.Banner)) {
      delete headers.Banner;
    }

    // --------------------------------------------------
    // CSRF / Authorization logic
    // --------------------------------------------------

    const isMainApi =
      url.includes("https://main-api-dev") ||
      url.includes("https://main-api-prod");

    if (isMainApi) {
      const csrfToken = localStorage.getItem("csrftoken");

      if (csrfToken) {
        headers["X-CSRF-Token"] = csrfToken;
      }

      delete headers.Authorization;
    }
    const fetchOptions: RequestInit = {
      method: mode ? mode.toUpperCase() : "GET",
      headers,
      body: model ? JSON.stringify(model) : null,
      ...(isMainApi && { credentials: "include" }),
    };

    return fetch(url, fetchOptions).then((response) => {
      const userDetails = JSON.parse(
        localStorage.getItem("userDetails") || "{}",
      );

      const byPassPing = userDetails?.byPassPing;

      // Handle Unauthorized / Forbidden FIRST
      if (response.status === 401 || response.status === 403) {
        console.log("Unauthorized / Forbidden:", response.status);
        console.log("byPassPing:", byPassPing);

        if (byPassPing == 1) {
          window.location.href = "/login";
          return Promise.reject(new Error("Unauthorized"));
        }

        const redirectURLSSO = this.util.isProd()
          ? environment.redirectURLSSOProd
          : environment.redirectURLSSODev;

        window.location.href = redirectURLSSO;

        return Promise.reject(new Error("Unauthorized"));
      }

      // Handle other HTTP errors
      if (!response.ok) {
        throw new Error(`HTTP ${response.status}`);
      }

      return response.json();
    });
  }

  handleError(error: HttpErrorResponse) {
    let errorMessage = "Unknown error!";
    if (error.error instanceof ErrorEvent) {
      // Client-side errors
      errorMessage = `Error: ${error.error.message}`;
    } else {
      // Server-side errors
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    window.alert(errorMessage);
    return throwError(errorMessage);
  }
}
